import { render, staticRenderFns } from "./ttshop_addinvoice.vue?vue&type=template&id=33691d2b&scoped=true&"
import script from "./ttshop_addinvoice.vue?vue&type=script&lang=js&"
export * from "./ttshop_addinvoice.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_addinvoice.vue?vue&type=style&index=0&id=33691d2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33691d2b",
  null
  
)

export default component.exports